module.exports = __webpack_public_path__ + "static/media/image-video-thumbnail.10427671.PNG";